import { AxiosError } from 'axios';
import { useEffect } from 'react';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { errorCodes } from 'src/utils/errors';

export const useApiErrorNavigator = (error: unknown): NavigateFunction => {
  const navigate = useNavigate();

  useEffect(() => {
    const isError = errorCodes.includes(
      (error as AxiosError)?.response?.status as number,
    );
    if (isError) {
      navigate('/not-found');
    }
  }, [error, navigate]);

  return navigate;
};
